import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import ApplicationApplicantInterface from '@api/requests/applications/interfaces/ApplicationApplicantInterface.interface';
import ApplicationInterface from '@api/requests/applications/interfaces/ApplicationInterface.interface';
import configRequest from '@api/requests/configRequest';

export interface BackgroundCheckApplicationFormData {
	application_id: number;
}

export interface BackgroundCheckApplicationFormResponse {
	application: ApplicationInterface & {
		applicants: ApplicationApplicantInterface[];
	};
}

const backgroundCheckApplicationForm = configRequest<
	BackgroundCheckApplicationFormResponse,
	BackgroundCheckApplicationFormData
>({
	requestPrefix: 'applications/backgroundCheckApplicationForm',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.APPLICATION_FORM.BACKGROUND_CHECK(),
		method: HTTP_METHODS_ENUM.POST,
		data: {
			...data,
			with: ['applicants.latest_background_check', 'current_status'],
		},
	}),
});

export default backgroundCheckApplicationForm;
